import {connect} from 'react-redux';
import AccountComponent from '../../Components/Account/index';
import {getMerchantDetail,generateApiKey,merchantKey, resetMerchantDetails,
    generateMerchantKey, setEndpoint, uploadUserPicture, getUserPicture} from '../../redux/actions/MerchantActions';
import { changePassword, userChangeAttribute, getUserLatestData } from '../../redux/actions/AuthActions';

const MerchantContainer = connect (
    (state) => {
        return {
            Merchant: state.MerchantReducer,
            User : state.authReducer.info.id,
            userRole: state.authReducer.info.userRoles,
            userInfo : state.authReducer.info,
            passwordChg : state.authReducer.isPasswordChg,
            isInfoChg : state.authReducer.isInfoChg,
            isProPicUpload : state.authReducer.isProPicUpload,
            picture: state.authReducer.info.picture
        };
    },
    (dispatch) => {
        return {
            getMerchantDetail: () => {
                dispatch(getMerchantDetail());
            },
            generateApiKey: () => {
                dispatch(generateApiKey());
            },
            merchantKey: (user, type) => {
                dispatch(merchantKey(user, type));
            },
            generateMerchantKey: (user) => {
                dispatch(generateMerchantKey(user));
            },
            setEndpoint: (url) => {
                dispatch(setEndpoint(url));
            },
            resetMerchantDetails: () => {
                dispatch(resetMerchantDetails());
            },
            changePassword: (userData) => {
                dispatch(changePassword(userData));
            },
            userChangeAttribute: (userId, userData) => {
                dispatch(userChangeAttribute(userId, userData));
            },
            getUserLatestData: () => {
                dispatch(getUserLatestData());
            },
            uploadUserPicture: (userId, picture) => {
                dispatch(uploadUserPicture(userId, picture));
            },
            getUserPicture: (userId) => {
                dispatch(getUserPicture(userId))
            }
        };
    }
)(AccountComponent);

export default MerchantContainer;